import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "context/PermissionsContext";
import { LoadingSpinner } from "common/Grid";
import { routes } from "./app-router/routes";
import { PermissionKeys } from "Constant/Constant";

const hasRequiredPermission = (allowedKeys = [], requiredPermission = null) => {
  if (!requiredPermission) return true;
  const requiredPermissions = Array.isArray(requiredPermission)
    ? requiredPermission
    : [requiredPermission];
  return requiredPermissions.some((permission) => allowedKeys.includes(permission));
};

const ProtectedPage = ({ children, requiredPermission = null }) => {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const { allowedKeys, role, isLoaded } = usePermissions();
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!isLoaded) {
    return <LoadingSpinner />;
  }

  const content = children || <Outlet />;
  const isAdmin = role === "Admin";
  if (isAdmin) return content;

  if (hasRequiredPermission(allowedKeys, requiredPermission)) {
    return content;
  }

  if (location.pathname === "/" && requiredPermission === PermissionKeys.VIEW_DASHBOARD) {
    const fallbackRoute = routes.find(
      (route) =>
        route.path !== "/" &&
        route.path !== "*" &&
        hasRequiredPermission(allowedKeys, route.requiredPermission)
    );
    
    if (fallbackRoute) {
      return <Navigate to={fallbackRoute.path} replace />;
    }
  }

  return <Navigate to="/unauthorized" replace />;
};

export default ProtectedPage;
